import "react-toastify/dist/ReactToastify.css";
import "react-loading-skeleton/dist/skeleton.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./containers/LandingPage/LandingPage";
import {
  GENERAL_DEBOUNCE_TIME,
  PROTECTED,
  ROUTES,
  TIMEOUT_MILLISECONDS,
} from "./common/constants";
import { RoutesConfigType } from "./common/types";
import LoginPage from "./containers/LoginPage/LoginPage";
import AuthContainer from "./containers/AuthContainer/AuthContainer";
import { ToastContainer } from "react-toastify";
import { useIdleTimer } from "react-idle-timer";
import { logout } from "./common/common";
import Dashboard from "./modules/sourcesDashboard/Dashboard";
import ArticlesDashboard from "./modules/ArticlesDashboard/ArticlesDashboard";

const RoutesConfig: RoutesConfigType = [
  // { path: ROUTES.error, element: <PageNotFound /> },
  { path: ROUTES.login, element: <LoginPage />, showFooter: false },
  {
    path: ROUTES.dashboard,
    element: <ArticlesDashboard />,
    type: PROTECTED,
    showFooter: false,
  },
  {
    path: "/generate-article/:session_id", 
    element: <Dashboard />,
    type: PROTECTED,
    showFooter: false,
  },
];

function App() {
  const location = window.location;
  const handleOnUserIdle = () => {
    logout();
  };

  useIdleTimer({
    timeout: TIMEOUT_MILLISECONDS,
    onIdle: handleOnUserIdle,
    debounce: GENERAL_DEBOUNCE_TIME,
    disabled: location.pathname === ROUTES.login,
  });

  return (
    <BrowserRouter>
      <Routes>
        {RoutesConfig.map((route, routeIndex) => {
          const isAdminRoute = route?.allowedUsers?.includes("admin");
          if (route?.type === PROTECTED) {
            if (isAdminRoute) {
              return (
                <Route
                  key={routeIndex}
                  path={route.path}
                  element={
                    <AuthContainer>
                      {/* <AdminContainer>{route.element}</AdminContainer> */}
                    </AuthContainer>
                  }
                />
              );
            }

            return (
              <Route
                key={routeIndex}
                path={route.path}
                element={
                  <AuthContainer>
                    <LandingPage
                      showFooter={route.showFooter}
                      haveRightContainer={route?.haveRightContainer}
                    >
                      {route.element}
                    </LandingPage>
                  </AuthContainer>
                }
              />
            );
          }
          return (
            <Route key={routeIndex} path={route.path} element={route.element} />
          );
        })}
      </Routes>

      <ToastContainer
        position="top-center"
        closeOnClick={true}
        pauseOnFocusLoss={false}
        newestOnTop={true}
        pauseOnHover={false}
      />
    </BrowserRouter>
  );
}

export default App;
